import type { GridRenderCellParams } from '@packages/fenrir/components/datagrid';
import { styled } from '@packages/fenrir/styles';

import { ConciergeTierBadge } from '../../concierge-tier-badge/concierge-tier-badge';
import type { BlueprintRow } from '../blueprints-table';

/* -------------------------------------------------------------------------------------------------
 * TierCell
 * -----------------------------------------------------------------------------------------------*/
const TierContainer = styled('div')({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
});

export const TierCell = (
  cellValues: GridRenderCellParams<BlueprintRow, BlueprintRow['tier']>,
) => {
  return (
    <TierContainer>
      <ConciergeTierBadge.Spidr tier={cellValues.row.tier} />
    </TierContainer>
  );
};
